<template>
  <!--发起的签署-->
  <div class="apply-list">
    <el-row type="flex" class="row">
      <el-col :span="signStatusSet !== '-2' ? 5 : 9"></el-col>
      <el-col :span="7" style="margin-right: 15px">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-select v-model="selectParam" placeholder="请选择" size="small">
              <el-option label="文件名称" value="contractName" />
              <!--<el-option label="文件编号" value="applyNo"/>-->
              <el-option label="签署方" value="signatoryFullName" />
              <!--<el-option label="手机号" value="signatoryMobile"/>-->
              <!--<el-option label="证件号" value="signatoryIdentityCard"/>-->
            </el-select>
          </el-col>
          <el-col :span="12">
            <el-input
              v-model="selectParamVal"
              size="small"
              placeholder="查询内容"
            />
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4" v-if="signStatusSet !== '-2'">
        <div style="text-align: center; white-space: nowrap">
          <el-select
            style="width: 140px"
            v-model="selectedStatus"
            placeholder="请选择"
            size="small"
          >
            <el-option
              v-for="(item, index) in statusEnum"
              :label="item.label"
              :key="'status' + index"
              :value="item.value"
              v-show="
                !$route.query.notMeSign ||
                ($route.query.notMeSign && item.value !== '0')
              "
            />
          </el-select>
        </div>
      </el-col>
      <el-col :span="5">
        <el-date-picker
          v-model="paramDateArr"
          type="daterange"
          value-format="yyyy-MM-dd"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          style="width: unset"
        />
      </el-col>
      <el-col :span="3" class="text-right">
        <el-row type="flex">
          <el-col :span="12" class="text-right">
            <el-button @click="queryFilter" size="small">查询</el-button>
          </el-col>
          <el-col :span="12" class="text-right">
            <el-button @click="rest" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!--草稿箱-->
    <el-table
      style="min-height: 54vh"
      v-if="signStatusSet === '-2'"
      :data="tableList"
      tooltip-effect="dark"
      v-loading="loading"
      @selection-change="handleSelectionChange"
      ref="dataList"
      class="data-list"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '500',
      }"
      key="type6"
    >
      <el-table-column type="selection" width="45" />
<!--      <el-table-column label="" width="90">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button v-if="scope.row.coEditingId" size="mini" type="primary"-->
<!--            >协同审阅</el-button-->
<!--          >-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="文件名称" prop="contractName" min-width="300">
        <template slot-scope="scope">
          <div
            style="
              display: flex;
              align-items: center;
              position: relative;
              padding-top: 10px;
            "
          >
            <span class="multiFile" v-if="scope.row.files > 1">多</span>
            <!-- <span class="multiFile" v-if="scope.row.multiFile">多</span> -->
            <template v-if="!isInDingTalk">
              <div
                class="custom-link textEllipsis"
                style="margin-right: 5px; opacity: 1"
                target="_blank"
                @click="toDetails(scope.row)"
              >
                <el-tooltip
                  effect="dark"
                  :content="scope.row.contractName"
                  placement="bottom-start"
                >
                  <span style="font-size: 16px">{{
                    scope.row.contractName
                  }}</span>
                </el-tooltip>
              </div>
            </template>
            <template v-else>
              <span
                class="custom-link textEllipsis"
                style="margin-right: 5px; opacity: 1"
              >
                <el-tooltip
                  effect="dark"
                  :content="scope.row.contractName"
                  placement="bottom-start"
                >
                  <span style="font-size: 16px" @click="dingTurn(scope.row)">{{
                    scope.row.contractName
                  }}</span>
                </el-tooltip>
              </span>
            </template>
          </div>
          <p class="textEllipsis">创建人：{{ scope.row.ebqUserName }}</p>
          <p class="textEllipsis">
            创建时间：{{ scope.row.createTime | formatDateHM }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="签署方" width="300">
        <template slot-scope="scope">
          <el-tooltip placement="bottom-start">
            <div
              slot="content"
              v-for="(item, index) in scope.row.signInfoVOS"
              :key="index"
              style="display: flex; align-items: center; padding-bottom: 5px"
            >
              <span
                v-if="item.orderNum && item.orderNum >= 1"
                style="
                  display: block;
                  width: 13px;
                  height: 13px;
                  border-radius: 50%;
                  color: #ffffff;
                  border: 1px solid #ffffff;
                  text-align: center;
                  line-height: 13px;
                  font-size: 12px;
                "
                >{{ item.orderNum }}</span
              >
              <span v-else style="color: #ffffff">·</span>
              <p style="color: #ffffff; font-size: 12px">
                &nbsp;{{ item.signatoryFullName }}
              </p>
            </div>
            <div>
              <p class="textEllipsis">
                {{ scope.row.signInfoVOS[0].signatoryFullName }}
              </p>
              <p class="textEllipsis" v-if="scope.row.signInfoVOS.length > 1">
                {{ scope.row.signInfoVOS[1].signatoryFullName}}
              </p>
              <template>
                <p
                  class="textEllipsis"
                  v-if="(scope.row.signInfoVOS.length === 3)"
                >{{ scope.row.signInfoVOS[2].signatoryFullName }}</p>
                <p class="textEllipsis" v-if="(scope.row.signInfoVOS.length > 3)">···</p>
              </template>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <!--      <el-table-column label="发起方" prop="ebqUserName" show-overflow-tooltip/>-->
      <!--      <el-table-column label="签署方" prop="allSignerName" show-overflow-tooltip/>-->
      <!--      <el-table-column label="创建时间" prop="createTime">-->
      <!--        <template slot-scope="scope" v-if="scope.row && scope.row.createTime">{{scope.row.createTime | formatDateHM}}</template>-->
      <!--      </el-table-column>-->
      <el-table-column label="创建时间" prop="createTime" width="180">
        <template slot-scope="scope" v-if="scope.row && scope.row.updateTime">
          <span style="color: rgba(41, 2, 2, 0.65)">{{
            scope.row.updateTime | formatDateHM
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope" v-if="!(scope.row.applyNo && scope.row.applyNo.startsWith('APLO'))">
          <template v-if="scope.row.coEditingId">
            <span
              @click="drftEditOrDing(scope.row)"
              class="color-success edit pointer"
              style="margin-right: 5px"
              >继续编辑
            </span>
            <!-- target="_blank" -->
          </template>
          <template v-else>
            <span class="color-success edit pointer" @click="elEdit(scope.row)"
              >编辑
            </span>
          </template>
        </template>
      </el-table-column>
      <no-data text="暂无数据" slot="empty" />
    </el-table>

    <!--非草稿箱-->
    <el-table
      v-else
      style="min-height: 54vh"
      :data="tableList"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      ref="dataList"
      :expand-row-keys="expandKeys"
      :row-key="
        (row) => {
          return row.applyId;
        }
      "
      @cell-mouse-enter="cellMouseEnter"
      @cell-mouse-leave="cellMouseLeave"
      v-loading="loading"
      class="data-list"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '500',
      }"
      key="typeOther"
    >
      <el-table-column type="selection" width="55" />
      <!--      <el-table-column label="" width="70" show-overflow-tooltip>-->
      <!--        <template slot-scope="scope">-->
      <!--          <div class="my-icon-box">-->
      <!--            <el-tooltip-->
      <!--              class="item"-->
      <!--              effect="dark"-->
      <!--              :content="(scope.row.tag || [])[0].tagName"-->
      <!--              placement="top"-->
      <!--              v-if="(scope.row.tag || [])[0]"-->
      <!--            >-->
      <!--              <i-->
      <!--                class="iconfont icontag pointer"-->
      <!--                :style="{ color: (scope.row.tag || [])[0].tagColour }"-->
      <!--                @click="setTag(null, scope.row)"-->
      <!--              ></i>-->
      <!--            </el-tooltip>-->
      <!--            <el-popover-->
      <!--              v-show="scope.row.showTag"-->
      <!--              placement="top"-->
      <!--              width="200"-->
      <!--              trigger="hover"-->
      <!--            >-->
      <!--              <i class="iconfont icontag pointer" slot="reference"></i>-->
      <!--              <div class="hover-win">-->
      <!--                <el-tooltip-->
      <!--                  class="item"-->
      <!--                  effect="dark"-->
      <!--                  :content="tag.tagName"-->
      <!--                  placement="top"-->
      <!--                  v-for="(tag, index) in tagLists"-->
      <!--                  :key="'tag_a' + index"-->
      <!--                >-->
      <!--                  <i-->
      <!--                    class="iconfont icontag pointer margin-lr-5"-->
      <!--                    @click="setTag(tag, scope.row)"-->
      <!--                    :style="{ color: tag.tagColour }"-->
      <!--                  ></i>-->
      <!--                </el-tooltip>-->
      <!--                <i-->
      <!--                  class="iconfont iconbianji pointer margin-lr-5"-->
      <!--                  @click="showTagManage()"-->
      <!--                ></i>-->
      <!--              </div>-->
      <!--            </el-popover>-->
      <!--          </div>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column label="文件名称">
        <template slot-scope="scope">
          <div
            style="
              display: flex;
              align-items: center;
              position: relative;
              padding-top: 10px;
            "
          >
            <span class="multiFile" v-if="scope.row.files > 1">多</span>
            <corp-apply-name
              applyType="applyList"
              :signInfo="{
                signStatus: scope.row.signStatus,
                selfSign: scope.row.selfSign,
                selfApprove: scope.row.selfApprove,
                signNo: scope.row.signNo,
                contractName: scope.row.contractName,
                applyNo: scope.row.applyNo,
                approveId: scope.row.approveId,
                multiFile: scope.row.multiFile,
                aiCorpUserIdFlag: scope.row.aiCorpUserIdFlag,
              }"
            />
            <span
              v-if="scope.row.vpresId"
              class="color-success"
              style="
                font-size: 12px;
                color: rgba(41, 2, 2, 0.65);
                cursor: default;
                flex: 1;
                min-width: 150px;
                padding-top: 5px;
              "
              >&nbsp;&nbsp;备案号：{{ scope.row.vpresId }}
              <!--<img src="../../../static/images/record.png" alt="">-->
            </span>
          </div>

          <p class="textEllipsis">发起方：{{ scope.row.ebqUserName }}</p>
          <p class="textEllipsis">
            发起时间：{{ scope.row.createTime | formatDateHM }}
            <el-tooltip
              effect="dark"
              content="由钉钉发起的"
              placement="bottom-start"
            >
              <img
                src="/images/icon/dingIcon.png"
                alt="钉钉"
                width="20px"
                v-if="scope.row.fromDingTalk && scope.row.fromDingTalk == 1 && !isInDingTalk"
              />
            </el-tooltip>
          </p>
        </template>
      </el-table-column>
      <!--暂时隐藏审批方-->
      <el-table-column v-if="false" label="审批方" show-overflow-tooltip>
        <template slot-scope="scope">
          <span
            v-if="scope.row.signStatus === -3 || scope.row.signStatus === -4"
          >
            {{ scope.row.allApproveName }}
          </span>
          <span v-else> - </span>
        </template>
      </el-table-column>
      <!--      <el-table-column label="发起方" prop="ebqUserName" show-overflow-tooltip/>-->
      <!--      <el-table-column label="签署方" prop="allSignerName" show-overflow-tooltip/>-->
      <el-table-column label="签署方">
        <template slot-scope="scope">
          <el-tooltip placement="bottom-start">
            <div
              slot="content"
              v-for="(item, index) in scope.row.signInfoVOS"
              :key="index"
              style="display: flex; align-items: center; padding-bottom: 5px"
            >
              <span
                v-if="item.orderNum && item.orderNum >= 1"
                style="
                  display: block;
                  width: 13px;
                  height: 13px;
                  border-radius: 50%;
                  color: #ffffff;
                  border: 1px solid #ffffff;
                  text-align: center;
                  line-height: 13px;
                  font-size: 12px;
                "
                >{{ item.orderNum }}</span
              >
              <span v-else style="color: #ffffff">·</span>
              <div style="color: #ffffff; font-size: 12px">
                【{{
                  item.signStatus === 0 || item.signStatus === -1
                    ? "未签署"
                    : item.signStatus === 1
                    ? "已签署"
                    : "已拒签"
                }}】
              </div>
              <p style="color: #ffffff; font-size: 12px">
                {{ item.signatoryFullName }}
              </p>
            </div>
            <div>
              <p class="textEllipsis">
                {{ scope.row.signInfoVOS[0].signatoryFullName }}
              </p>
              <p class="textEllipsis" v-if="scope.row.signInfoVOS.length > 1">
                {{ scope.row.signInfoVOS[1].signatoryFullName}}
              </p>
              <template>
                <p
                  class="textEllipsis"
                  v-if="(scope.row.signInfoVOS.length === 3)"
                >{{ scope.row.signInfoVOS[2].signatoryFullName }}</p>
                <p class="textEllipsis" v-if="(scope.row.signInfoVOS.length > 3)">···</p>
              </template>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <template v-if="scope.row.signStatus === -3">
            <span v-if="scope.row.selfApprove === 1" class="red">待我审</span>
            <span v-else class="blue">待ta审</span>
          </template>
          <template v-else-if="scope.row.signStatus === -4">
            <p class="orange">审批驳回</p>
          </template>
          <template v-else-if="scope.row.signStatus === 0">
            <p v-if="scope.row.selfSign === 1" class="red">待我签</p>
            <p v-else class="blue">待ta签</p>
          </template>
          <template v-else-if="scope.row.signStatus === 1">
            <span class="green">已完成</span>
          </template>
          <template v-else-if="scope.row.signStatus === 2">
            <span class="orange">已拒签</span>
          </template>
          <template v-else-if="scope.row.signStatus === -5">
            <span class="grey">已撤销</span>
          </template>
          <template v-else-if="scope.row.signStatus === -6">
            <span class="grey">已过期</span>
          </template>
        </template>
      </el-table-column>
      <!--      <el-table-column label="发起时间" prop="createTime">-->
      <!--        <template slot-scope="scope">{{scope.row.createTime | formatDateHM}}</template>-->
      <!--      </el-table-column>-->
      <!-- <el-table-column type="expand" width="1">
        <template slot-scope="scope">
          <el-form inline class="demo-table-expand">
            <el-form-item>
              <more-button
                :rowData="scope.row"
                :showMoreBtn="true"
                @btnMethodFn="openLYDialog"
              ></more-button>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="180">
        <template slot-scope="scope" v-if="!(scope.row.applyNo && scope.row.applyNo.startsWith('APLO'))">
          <corp-handles
            v-if="scope.row.signStatus !== 1"
            ref="handlesComp"
            :rowData="scope.row"
            applyType="applyList"
            @resetList="getSignLists"
          ></corp-handles>
          <!--          <div-->
          <!--            v-if="scope.row.signStatus === 1"-->
          <!--            @click="openLYDialog(scope.row)"-->
          <!--            class="com-normal-btn"-->
          <!--          >-->
          <!--            上传履约文件-->
          <!--          </div>-->
          <template v-if="scope.row.signStatus === 1">
            <!--            <span-->
            <!--              v-if="scope.row.vpresId"-->
            <!--              id="tag-copy"-->
            <!--              :data-clipboard-text="scope.row.vpresId"-->
            <!--              @click="copyTextToQuery(scope.row.vpresId)"-->
            <!--              class="com-normal-btn"-->
            <!--            >-->
            <!--                存证查询-->
            <!--              </span>-->
            <existing-evidence
              :rowData="scope.row"
              @copyTextToQueryEmit="copyTextToQuery"
            >
            </existing-evidence>
            <!-- <div class="com-normal-btn" @click="moreBtnShowFn(scope.row)">
              更多操作
            </div> -->
            <el-dropdown
              trigger="click"
              @visible-change="visiChange($event, scope.row.applyId)"
            >
              <span class="com-normal-btn pointer">
                更多操作
                <i
                  :class="
                    visiDown.status && visiDown.rowApplyId == scope.row.applyId
                      ? 'el-icon-caret-top'
                      : 'el-icon-caret-bottom'
                  "
                  class="com-normal-btn el-icon--right"
                ></i>
              </span>
              <el-dropdown-menu
                slot="dropdown"
                style="background-color: #f5f6f6"
              >
                <more-button
                  :rowData="scope.row"
                  :showMoreBtn="true"
                  @btnMethodFn="openLYDialog"
                ></more-button>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </template>
      </el-table-column>
      <no-data text="暂无数据" slot="empty" />
    </el-table>
    <div class="bulkOperation" v-if="batchLength && false">
      已选{{ batchLength }}份文件
    </div>
    <!--分页-->
    <el-row class="pageation row">
      <el-col :span="5">
        <template v-if="$route.query.directoryId">
          <el-button @click="emitFn('dirMove')" size="small">归档</el-button>
          <el-button @click="emitFn('removeFromDir')" size="small"
            >移除</el-button
          >
        </template>
        <template v-if="$route.query.notMeSign">
          <el-button @click="emitFn('saveToDir')" size="small">归档</el-button>
        </template>
        <template style="height: 20px" v-if="$route.query.signStatus === '4'">
          <el-button @click="emitFn('deleteFromDir')" size="mini"
            >删除</el-button
          >
        </template>
        <!--  抄送按钮，除开抄送列表      -->
        <el-button
          v-if="$route.query.signStatus !== '4'"
          @click="selectCcUserFn()"
          size="small"
          >抄送</el-button
        >
      </el-col>
      <el-col :span="19" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.itemPage"
          :pager-count="5"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParam.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="queryParam.total"
        />
        <el-go
          :page-size="queryParam.pageSize"
          :total="queryParam.total"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
    </el-row>
    <!--用户扫码签选择用户 弹窗-->
    <el-dialog
      title="选择签署方"
      :visible.sync="visibleNoSignList"
      modal-append-to-body
      append-to-body
      :close-on-click-modal="false"
      :show-close="false"
      width="550px"
    >
      <el-row v-if="noSign.data">
        <el-col
          v-for="(item, index) in noSign.data"
          :span="8"
          :key="index"
          style="margin-bottom: 10px"
          class="font-ellipsis"
        >
          <a
            @click="getNoSignUrl(item)"
            :title="item.fullName"
            href="javascript:void (0)"
            class="color-success"
            >{{ item.fullName | ellipsis(8) }}</a
          >
        </el-col>
      </el-row>
      <p class="text-right">
        <el-button @click="visibleNoSignList = false" size="small"
          >取消
        </el-button>
      </p>
    </el-dialog>
    <!--合同未签署方URL 弹窗-->
    <el-dialog
      :visible.sync="visibleNoSignUrl"
      modal-append-to-body
      append-to-body
      width="340px"
    >
      <div v-if="noSign.url" class="text-center nosign-url">
        <p>{{ noSign.name }}的签署链接</p>
        <qrcode :value="noSign.url" :size="200" leave="H" key="evidence" />
        <p style="margin-bottom: 10px">{{ noSign.url }}</p>
        <p>
          <el-button
            @click="visibleNoSignUrl = false"
            type="success"
            size="small"
            >确定
          </el-button>
        </p>
      </div>
    </el-dialog>

    <!-- 手写loading -->
    <div
      v-show="batchLoading"
      style="
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 1900;
      "
      v-loading="batchLoading"
      element-loading-text="合同发起中，请勿关闭当前页面"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
    ></div>
    <!--标签管理-->
    <tag-manage
      @close="getTagList"
      @refresh="getSignLists"
      :isCrop="true"
      ref="tagManage"
    />

    <!--履约文件-->
    <el-dialog
      title="履约文件"
      :visible.sync="lYDialogVisible"
      width="850px"
      class="ly-info"
    >
      <el-tabs v-model="activeName" class="ly-mask" @tab-click="handleClick">
        <el-tab-pane label="上传原文件" name="1">
          <p class="tips">
            支持常见图片、文档、视频、音频、压缩包格式，上传后会保存原文件，单个文件大小不超过30MB
          </p>
          <div class="box-wrap">
            <div class="temone add">
              <span class="el-icon-plus"></span>
              <input
                ref="referenceUpload"
                type="file"
                class="file-ipt"
                @change="handleInputChange"
              />
            </div>

            <div class="temone" v-for="(item, idx) in lYDialogData" :key="idx">
              <div class="t-box">
                <img class="y-img" src="/images/web/file-icon.png" />
                <div class="msk">
                  <span class="des"
                    >上传人：{{ item.userName }} -{{ item.accountName }}</span
                  >
                </div>
              </div>

              <div class="a-btn">
                <a class="has-hover" :href="downloadLYFile(item.file)">下载</a>
                <a
                  v-if="isDoc(item)"
                  class="has-hover"
                  @click="previewDoc(item)"
                  >预览</a
                >
                <a
                  v-if="isVideoOrImg(item)"
                  class="has-hover"
                  @click="previewVideOrImg(item)"
                  >预览</a
                >
                <a
                  v-if="item.canDelete"
                  class="has-hover"
                  @click="delLYFile(item)"
                  >删除</a
                >
                <a class="no-hover">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="上传文件哈希" name="2">
          <p class="tips">
            格式没有限制，仅保存上传文件的特征值（哈希），不对文件本身做保存，单个文件大小不超过500M
          </p>

          <div class="box-wrap">
            <div class="temone add">
              <span class="el-icon-plus"></span>
              <input
                ref="referenceUpload1"
                type="file"
                class="file-ipt"
                @change="handleInputChange"
              />
            </div>

            <div class="temone" v-for="(item, idx) in lYDialogData" :key="idx">
              <div class="t-box">
                <img class="y-img" src="/images/web/hash-icon.png" />
                <div class="msk">
                  <span class="des"
                    >上传人：{{ item.userName }} -{{ item.accountName }}</span
                  ><br />
                  <span class="des" style="margin: 0">备案号：{{ item.presId }}</span>
                </div>
              </div>

              <div class="a-btn">
                <a class="has-hover" @click="validLYFile(item)">验证</a>
                <a
                  v-if="item.canDelete"
                  class="has-hover"
                  @click="delLYFile(item)"
                  >删除</a
                >
                <a class="no-hover">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="footer">
        <span class="num"
          >文件数：<label>{{ lYDialogData.length }}</label
          >个</span
        >
        <el-button type="primary" size="small" class="cancel-btn" @click="lYDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!--pdf文件预览-->
    <ViewFilesToDoc
      :visibleShow="visibleShowEnclosureDoc"
      :enclosurePreviewNumItem="enclosurePreviewNumItem"
      @setViewFilesToDocDialogData="onSetViewFilesToDocDialogData"
    />
    <!--附件图片video预览显示-->
    <ViewFilesToImg
      :visibleShow="visibleShowEnclosure"
      :isRefresh="isRefresh"
      :enclosurePreviewNumItem="enclosurePreviewNumItem"
      :imgList="getEnclosureImgList"
      @setViewFilesToImgDialogData="onSetViewFilesToImgDialogData"
      style="text-align: center"
    />
    <!--  提示展示批量签署时提醒签章   -->
    <el-dialog
      :visible.sync="nodeQueryVisible"
      custom-class="data-dialog"
      width="800px"
      destroy-on-close
    >
      <div class="node_header" slot="title">保全链节点查询</div>
      <p style="padding: 10px">当前合同备案号：{{ vpresId }}</p>
      <node-query :vpresId="vpresId" />
    </el-dialog>
    <!--  选择抄送人  -->
    <selectCcUser
      ref="selectCcUserRef"
      @clearListFn="clearListFn"
      :applyNosArr="applyNosArr"
    />
  </div>
</template>

<script>
import existingEvidence from "@/components/apply-list/existing-evidence";
import moreButton from "@/components/apply-list/more-button";
import nodeQuery from "@/components/signInfo/node-query";
import certiServicepopover from "@/components/apply-list/certiServicepopover";
import {
  ApiMethods,
  configUrl,
  getFindFileDownload
} from "@/assets/js/http-serve/http-methods";
import {
  ApiCorpMethods,
  noSignList,
  noSignUrl,
  postApplyPage,
  postApplyBadge,
  applyViewUrl
} from "@/assets/js/http-serve/corp/http-methods";
import Qrcode from "qrcode.vue";
import ElGo from "@/components/go/Go";
import CorpHandles from "@/components/apply-list/corpHandles";
import CorpApplyName from "@/components/apply-list/corpContractName";
import TagManage from "@/components/tag-manage";
import ViewFilesToDoc from "@/components/viewFiles/ViewFilesToDoc";
import ViewFilesToImg from "@/components/viewFiles/ViewFilesToImg";
import sha512Crypto from "js-sha512";
import Clipboard from "clipboard";
import selectCcUser from "@/components/selectCcUser/index";
import { isInDingTalk, authentication } from '@/assets/js/utils/ding-env';
export default {
  components: {
    existingEvidence,
    moreButton,
    nodeQuery,
    certiServicepopover,
    Qrcode,
    ElGo,
    CorpHandles,
    CorpApplyName,
    TagManage,
    ViewFilesToDoc,
    ViewFilesToImg,
    selectCcUser,
  },
  data () {
    return {
      isInDingTalk,
      applyNosArr: [],
      visiDown: {
        status: false,
        rowApplyId: ""
      },
      nodeQueryVisible: false, //节点查询
      vpresId: "",
      expandKeys: [],
      getDTag: false,
      tagLists: [],
      // 批量签loading
      batchLoading: false,
      tableList: [],
      // 请求参数
      queryParam: {
        itemPage: 1,
        pageSize: 10,
        total: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        searchType: null,
        signStatusSet: "",
        newVersion: 1,
      },
      selectParam: "contractName",
      selectedStatus: "",
      selectParamVal: "",
      directoryId: null,
      paramDateArr: null,
      signStatusSet: null,
      signStatus: null,
      badge: 0,
      // 加载中显示
      loading: true,
      checkedList: [],
      // 合同没有签署的签署方信息和url
      noSign: { data: null, url: "", name: "" },
      visibleNoSignList: false,
      visibleNoSignUrl: false,
      batchLength: null,

      //履约文件数据
      lYDialogVisible: false, //履约文件弹窗
      lYDialogData: [], //履约文件列表
      activeName: "1", //1：文件上传，2：hash值上传
      visibleShowEnclosure: false,
      visibleShowEnclosureDoc: false,
      enclosurePreviewNumItem: {}, // 当前预览项
      isRefresh: true, // 预览附件时，强制刷新
      rowData: {}
    };
  },
  beforeCreate () {
    if (this.$route.query.match) {
      this.$router.replace({
        path: "/corp/signInfo/signList",
        query: { signStatus: 4 }
      })
    }
    return false;
  },
  created () {
    let query = this.$route.query;
    this.signStatus = query ? ~~query.signStatus : 1;
    this.directoryId = query ? query.directoryId : null;
    this.queryParam["directoryId"] = this.directoryId;
    this.signStatusFn(this.signStatus);
    this.checkContractBatch();
    this.getTagList();
  },
  destroyed () {
    this.batchLength = null;
    this.$emit("batchLength", this.batchLength);
  },
  computed: {
    draftEdit () {
      return function (status) {
        return status ? "/initiation/toCreate" : "/applySign/toCreate";
      };
    },
    statusEnum () {
      return [
        {
          label: "全部",
          value: "-1"
        },
        {
          label: "待我审",
          value: "6"
        },
        {
          label: "待ta审",
          value: "7"
        },
        {
          label: "待我签",
          value: "0"
        },
        {
          label: "待ta签",
          value: "1"
        },
        {
          label: "已完成",
          value: "2"
        },
        {
          label: "已拒签",
          value: "3"
        },
        {
          label: "已过期",
          value: "4"
        },
        {
          label: "已撤销",
          value: "5"
        },
        {
          label: "审批驳回",
          value: "8"
        }
      ];
    },
    // 获取附件中的图片列表，用于预览
    getEnclosureImgList () {
      let a = this.lYDialogData.filter(item => {
        return this.isVideoOrImg(item);
      });
      return a;
    }
  },
  watch: {
    paramDateArr: {
      handler (val) {
        if (val && val.length === 2) {
          this.queryParam.beginDate = val[0];
          this.queryParam.endDate = val[1];
        } else {
          this.queryParam.beginDate = this.queryParam.endDate = null;
        }
      },
      deep: true
    },
    selectedStatus: function (val) {
      this.queryParam["selfSign"] = null;
      this.queryParam["selfApprove"] = null;
      this.queryParam["signStatusSet"] = this.signStatusSet;
      switch (val) {
        case "0":
          this.queryParam["signStatusSet"] = "0";
          this.queryParam["selfSign"] = 1;
          break;
        case "1":
          this.queryParam["signStatusSet"] = "0";
          this.queryParam["selfSign"] = 0;
          break;
        case "2":
          this.queryParam["signStatusSet"] = "1";
          break;
        case "3":
          this.queryParam["signStatusSet"] = "2";
          break;
        case "4":
          this.queryParam["signStatusSet"] = "-6";
          break;
        case "5":
          this.queryParam["signStatusSet"] = "-5";
          break;
        case "6":
          this.queryParam["signStatusSet"] = "-3";
          this.queryParam["selfApprove"] = 1;
          break;
        case "7":
          this.queryParam["signStatusSet"] = "-3";
          this.queryParam["selfApprove"] = 0;
          break;
        case "8":
          this.queryParam["signStatusSet"] = "-4";
          break;
      }
    },
    selectParamVal: function (val) {
      this.queryParam[this.selectParam] = val;
    },
    selectParam: function (newVal, oldVal) {
      this.queryParam[newVal] = this.queryParam[oldVal];
      this.queryParam[oldVal] = null;
    },
    // signStatusSet: function(val) {
    //   this.computeQueryParam(val);
    //   this.getSignLists();
    // },
    // signStatus(val) {
    //   switch (val) {
    //     case 1:
    //       this.signStatusSet = "";
    //       break;
    //     case 2:
    //       this.signStatusSet = "0,-3";
    //       break;
    //     case 3:
    //       this.signStatusSet = "1,2,-4,-5,-6";
    //       break;
    //     case 4:
    //       this.signStatusSet = "-2";
    //       break;
    //     default:
    //       this.signStatusSet = "";
    //       break;
    //   }
    // },
    directoryId (val) {
      // this.queryParam["directoryId"] = val;
      // this.getSignLists();
    },
    $route: {
      handler () {
        if (this.$route.query.match) {
          this.$router.replace({
            path: "/corp/signInfo/signList",
            query: { signStatus: 4 }
          })
          return false;
        }
        this.resetScreenParams();
        let query = this.$route.query;
        this.signStatus = query ? ~~query.signStatus : 1;
        this.directoryId = query ? query.directoryId : null;
        this.queryParam["directoryId"] = this.directoryId;
        this.signStatusFn(this.signStatus);
      },
      deep: true
    }
  },
  methods: {
    toDetails(row){
      if((row.applyNo && row.applyNo.startsWith('APLO'))){
        return this.$message.warning('国际版发起的文件请前往 FairSigning 操作!');
      }
      if (row.coEditingId) {
        this.$router.push({
          path: '/initiation/collaborationEdit',
          query: {
            drafts: 1,
            draftCoEditingSec: row.coEditingId,
          },
        })
      } else {
        this.$router.push({
          // path: scope.row.multiFile ? '/initiation/toCreate' : '/applySign/toCreate',
          path: this.draftEdit(row.multiFile),
          query: {
            applyId: row.applyIdSec,
            isCorp: true,
            aiCorpUserIdFlag: row.aiCorpUserIdFlag,
          },
        })
      }
    },
    drftEditOrDing (row) {
      this.turnOffice({
        // path: '/initiation/toCreate',
        path: '/initiation/collaborationEdit',
        query: {
          drafts: 1,
          draftCoEditingSec: row.coEditingId,
        },
      })
    },
    elEdit (row) {
      const path = {
        path: row.multiFile ? "/initiation/toCreate" : "/applySign/toCreate",
        query: {
          applyId: row.applyIdSec,
          isCorp: true,
          aiCorpUserIdFlag: row.aiCorpUserIdFlag,
        },
      }
      const newPath = this.$router.resolve(path);
      isInDingTalk ? this.$router.push(path) : window.open(window.location.origin + newPath.href, "_blank")
    },
    dingTurn (row) {
      const href = {
        path: row.multiFile ? "/initiation/toCreate" : "/applySign/toCreate",
        query: {
          applyId: row.applyIdSec,
          isCorp: true,
          aiCorpUserIdFlag: row.aiCorpUserIdFlag,
        }
      }
      this.$router.push(href)
    },
    turnOffice (pathObj) {
      let routeUrl = this.$router.resolve(pathObj);
      isInDingTalk ? this.$router.push(pathObj) : window.open(routeUrl.href, "_blank");
    },
    emitFn (fn) {
      this.$emit("emitFn", fn);
    },
    //NO3
    signStatusSetFn (val) {
      this.queryParam = {
        itemPage: 1,
        pageSize: 10,
        total: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        directoryId: this.directoryId,
        signStatusSet: val,
        createType: 1,
        newVersion: 1,
        showAll: 1,
      };
      this.getSignLists();
    },
    //NO2
    signStatusFn (val) {
      switch (val) {
        case 1:
          this.signStatusSet = "";
          break;
        case 2:
          this.signStatusSet = "0,-3";
          break;
        case 3:
          this.signStatusSet = "1,2,-4,-5,-6";
          break;
        case 4:
          this.signStatusSet = "-2";
          break;
        default:
          this.signStatusSet = "";
          break;
      }
      this.signStatusSetFn(this.signStatusSet);
    },
    visiChange (val, rowApplyId) {
      this.visiDown = {
        status: val,
        rowApplyId
      };
    },
    //选择抄送
    selectCcUserFn () {
      let arr = this.$refs["dataList"].selection || [];
      if (!arr.length) {
        return this.$message.error('请先选择文件');
      } else {
        this.applyNosArr = arr.map((item) => {
          return item.applyNo
        });
        this.$refs.selectCcUserRef.show();
      }
    },
    clearListFn () {
      this.$refs["dataList"].clearSelection()
    },
    // 复制并查询
    copyTextToQuery (vpresId) {
      this.vpresId = vpresId;
      this.nodeQueryVisible = true;
    },
    //更多按钮展开
    moreBtnShowFn (obj) {
      if (this.expandKeys[0] === obj.applyId) {
        this.expandKeys = [];
      } else {
        this.expandKeys = [obj.applyId];
      }
    },
    getTagList () {
      ApiMethods.CorpUserTagController.getAllUserTagList().then(res => {
        if (!res.success)
          return this.$message.error(res.description || this.$tip);
        if ((res.data || []).length === 0 && !this.getDTag)
          return this.getDefaultTag();
        this.tagLists = res.data;
      });
    },
    getDefaultTag () {
      this.getDTag = true;
      ApiMethods.CorpUserTagController.getDefaultTag().then(res => {
        if (!res.success)
          return this.$message.error(res.description || this.$tip);
        this.getTagList();
      });
    },
    setTag (tag, row) {
      this.$refs.tagManage.setTag(tag, row, 0).then(res => {
        if (!res.success)
          return this.$message.error(res.description || "操作失败");
        this.$set(row, "tag", []);
        tag && row.tag.push(tag);
      });
    },
    cellMouseEnter (row) {
      this.$set(row, "showTag", true);
    },
    cellMouseLeave (row) {
      row.showTag = false;
    },
    showTagManage () {
      this.$refs.tagManage.setVisible(true);
    },
    resetScreenParams () {
      this.selectParam = "contractName";
      this.selectedStatus = "";
      this.selectParamVal = "";
      this.queryParam = {
        itemPage: 1,
        pageSize: 10,
        total: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        signStatusSet: null,
        createType: 1,
        newVersion: 1,
      };
      this.paramDataArr = null;
      this.signStatus = null;
      this.directoryId = null;
    },
    // 批量发起合同生成检查
    checkContractBatch () {
      /*let query = this.$route.query
          let snapshotId = undefined
          if (localStorage.getItem('snapshotId')) {
            snapshotId = parseInt(localStorage.getItem('snapshotId'))
            let params = {}
            params.snapshotId = snapshotId
            this.batchLoading = true
            // 个人
            if (query.orderNumber) {
              params.orderNo = query.orderNumber
              this.findOrderInterval(params)
            } else {
              // 集团
              this.findOrderIntervalCorp(params)
            }
          }*/
      let query = this.$route.query;
      if (query.snapshotId) {
        let params = {
          snapshotId: query.snapshotId,
          orderNo: query.orderNumber || null
        };

        this.batchLoading = true;
        this.findOrderIntervalCorp(params);
      }
    },
    // 批量发起集团用户
    findOrderIntervalCorp (params) {
      ApiCorpMethods.BatchContractController.findOrderCorp(params)
        .then(res => {
          if (res.code === "0") {
            if (res.data.success > 0) {
              this.batchLoading = false;
              this.$alert(`成功发起${res.data.success}份`, "", {
                confirmButtonText: "确定",
                callback: action => {
                  const query = Object.assign({}, this.$route.query);
                  delete query.snapshotId;
                  this.$router.push({ path: this.$route.path, query: query });
                  this.queryFilter();
                }
              });
            } else {
              setTimeout(() => {
                this.findOrderIntervalCorp(params);
              }, 2000);
            }
          } else {
            this.batchLoading = false;
            this.$message.error(
              res.description || "批量发起失败，请刷新后再试"
            );
          }
        })
        .catch(err => {
          this.batchLoading = false;
          this.$message.error(err.description || "批量发起失败，请刷新后再试");
        });
    },

    computeQueryParam (signStatusSet) {
      this.queryParam = {
        itemPage: 1,
        pageSize: 10,
        total: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        searchType: null,
        signStatusSet: signStatusSet,
        newVersion: 1,
        createType: 1,
      };
    },
    // 催签
    reminderSign (sign) {
      var param = {
        signInfoId: sign.signInfoId || null,
        applyId: sign.applyId || null,
        returnURL: window.location.href
      };

      ApiMethods.SendSms4SignController.reminderSign(param)
        .then(res => {
          // data参数：{cashierUrl:'', money: '', orderNumber: '', point: ''}
          var data = res.data;
          if (res.success || res.success === "true") {
            if (res.data.recharge) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            } else {
              this.$confirm(`需消耗${data.point}积分/次`, "支付提示", {
                showConfirmButton: true,
                showCancelButton: true,
                type: "info"
              }).then(() => {
                ApiMethods.SendSms4SignController.reminderSign(
                  Object.assign(param, { pay: 1 })
                ).then(res => {
                  if (+res.code === 10806) {
                    this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
                    return;
                  }
                  if (+res.code === 0) return this.$message.success("催签成功");
                  this.$message.error(res.description || "支付失败");
                });
              });
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(err => {
          this.$message.error(err.description || "数据初始化失败");
        });
    },
    getNoSignUrl (sign) {
      noSignUrl(sign.signNo).then(({ data }) => {
        if (data) {
          this.noSign.url = data;
          this.noSign.name = sign.fullName;
          this.visibleNoSignUrl = true;
        }
      });
    },
    // 获取合同没有签署的签署方信息
    getNoSingInfo (applyNo) {
      if (!applyNo) return;
      noSignList({ applyNo: applyNo }).then(({ data }) => {
        this.noSign.data = data || null;
        this.visibleNoSignList = true;
      });
    },
    // 重置
    rest () {
      this.selectParam = "contractName";
      this.selectParamVal = "";
      this.selectedStatus = "";
      this.paramDateArr = null;
      this.queryFilter();
    },
    // 查询 筛选
    queryFilter: function () {
      this.queryParam.itemPage = 1;
      this.queryParam.pageSize = 10;
      this.getSignLists();
    },
    // 获取合同列表
    getSignLists () {
      this.loading = true;
      this.batchLength = null;
      this.$emit("batchLength", this.batchLength);
      let newPar = {
        ...this.queryParam,
      }
      if (this.$route.query.notMeSign) {
        newPar.excludeSelfSign = 1;
      }
      postApplyPage(newPar)
        .then(data => {
          this.queryParam.itemPage = data.pageNum;
          this.queryParam.pageSize = data.pageSize;
          this.queryParam.total = data.total;
          this.tableList = data.data;
          // if (window.location.href.indexOf("match") > -1) {
          //   this.getApplyBadge();
          // } else {
          this.badge = data.total;
          this.$emit("update:badge", data.total);
          // }
        })
        .catch(e => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getApplyBadge () {
      postApplyBadge(this.queryParam).then(data => {
        this.badge = data.total;
        this.$emit("update:badge", data.total);
      });
    },
    handleSizeChange (val) {
      this.queryParam.itemPage = 1;
      this.queryParam.pageSize = val;
      this.getSignLists();
    },
    handleCurrentChange (val) {
      this.queryParam.itemPage = val;
      this.getSignLists();
    },
    filterTag: function (row, column) {
      return row === column.status;
    },
    handleSelectionChange: function (val) {
      this.checkedList = val;
      this.batchLength = val.length;
      this.$emit("batchLength", this.batchLength);
    },
    to: function (url, target) {
      window.open(url, target);
    },
    //履约文件相关 882需求新增
    openLYDialog (rowData) {
      this.lYDialogVisible = true;
      this.rowData = rowData;
      this.setLYDialogData();
    },
    //展示履约文件弹窗
    async setLYDialogData () {
      let _this = this;
      let param = {
        uploadType: this.activeName,
        applyNo: this.rowData.applyNo || ""
      };
      let res = await ApiMethods.PerformanceController.getList(param);
      if (res.success) {
        this.lYDialogData = res.data;
      } else {
        _this.$message.error(res.description);
      }
    },
    // 获取附件后缀
    getEnclosureSuffix (item) {
      if (item.fileName) {
        let arr = item.fileName.split(".");
        return arr[arr.length - 1];
      }
      return "";
    },
    // 附件是否文档
    isDoc (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['DOCX','DOC','PDF','XLS','XLSX']
      let arr = ["PDF"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 附件是否图片或视频
    isVideoOrImg (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['DOCX','DOC','PDF','XLS','XLSX']
      let arr = ["PNG", "GIF", "JPG", "JPEG", "MP4", "WEBM", "OGG"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 预览履约文件图片或者视频
    previewVideOrImg (item) {
      this.enclosurePreviewNumItem = item;
      this.visibleShowEnclosure = true;
      // 刷新预览弹窗，更新
      this.isRefresh = false;
      this.$nextTick(() => {
        this.isRefresh = true;
      });
    },
    // 预览履约文件文档
    previewDoc (item) {
      this.enclosurePreviewNumItem = item;
      this.visibleShowEnclosureDoc = true;
    },

    //删除履约文件
    delLYFile (item) {
      this.$confirm("该操作删除后的文件将无法恢复，确认删除？", "系统提示", {
        showCancelButton: true,
        showCancelButton: true,
        type: "info"
      })
        .then(() => {
          ApiMethods.PerformanceController.del({
            performanceId: item.performanceId
          })
            .then(data => {
              if (data.success) {
                this.setLYDialogData();
              } else {
                _this.$message.error(data.description);
              }
            })
            .catch(err => {
              this.$message.error(
                err.description || "删除失败，请刷新后再试！"
              );
            });
        })
        .catch(() => { });
    },
    //下载履约文件
    downloadLYFile (item) {
      if (!item || item === "null" || item === "false")
        return "javascript:void(0)";
      if (item.fileName === "blob") {
        item.fileName = "attachment.png";
        item.fix = ".png";
      }
      return getFindFileDownload(item);
    },
    // 执行预览图片视频关闭后参数回传
    onSetViewFilesToImgDialogData (data) {
      this.visibleShowEnclosure = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 执行预览PDF关闭后参数回传
    onSetViewFilesToDocDialogData (data) {
      this.visibleShowEnclosureDoc = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 上传履约文件
    handleInputChange: function (e) {
      e = e.target;
      let param = { file: e.files[0] };
      if (!param.file) return;
      var frm = new FormData();
      if (+this.activeName == 1) {
        if (param.file.size > 30 * 1024 * 1024) {
          e.value = "";
          param = { file: "" };

          return this.$confirm(`上传的签章文件不能超过30M`, "系统提示", {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning"
          })
            .then(() => { })
            .catch(() => { });
        }
        frm.append("file", param.file);
        frm.append("fileName", e.files[0].name);
        frm.append("uploadType", this.activeName);
        frm.append("applyNo", this.rowData.applyNo);
        ApiMethods.PerformanceController.upload(frm)
          .then(res => {
            this.$refs.referenceUpload.value = null;
            if (res.success) {
              this.$message.success("上传成功");
              this.setLYDialogData();
            } else {
              this.$message.error(res.description);
            }
          })
          .catch(e => {
            this.$message.error(e.description);
          });
      } else {
        if (param.file.size > 500 * 1024 * 1024) {
          e.value = "";
          param = { file: "" };

          return this.$confirm(`上传的签章文件不能超过500M`, "系统提示", {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning"
          })
            .then(() => { })
            .catch(() => { });
        }
        let _this = this;
        let targetFileHash = "";
        const sha512 = sha512Crypto.create();
        _this.fileSliceDeal(
          e.files[0],
          1024 * 1024 * 2,
          function (fileSlice) {
            sha512.update(fileSlice);
          },
          function () {
            targetFileHash = sha512.hex();
            frm.append("hashValue", targetFileHash);
            frm.append("fileName", e.files[0].name);
            frm.append("uploadType", _this.activeName);
            frm.append("applyNo", _this.rowData.applyNo);
            ApiMethods.PerformanceController.upload(frm)
              .then(res => {
                _this.$refs.referenceUpload1.value = null;
                if (res.success) {
                  _this.$message.success("上传成功");
                  _this.setLYDialogData();
                } else {
                  _this.$message.error(res.description);
                }
              })
              .catch(e => {
                _this.$message.error(e.description);
              });
          }
        );
      }
    },

    handleClick (tab) {
      this.activeName = tab.name;
      this.setLYDialogData();
    },
    validLYFile (item) {
      window.open(
        "https://www.ebaoquan.org/query?type=2&bah=" + item.presId,
        "_blank"
      );
      // window.open(
      //   "http://sandbox.ebaoquan.org/query?type=2&bah=" + item.presId,
      //   "_blank"
      // );
    },
    fileSliceDeal: function (file, sliceSize, dealFun, finishFun) {
      var startTime = new Date().getTime();
      var chunkSize = file.size;
      var chunks = 1;
      var blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      if (blobSlice) {
        chunkSize = sliceSize;
        chunks = Math.ceil(file.size / chunkSize);
      }
      var currentChunk = 0;
      var fileReader = new FileReader();
      fileReader.onload = function (e) {
        dealFun(e.target.result, currentChunk, chunks);
        currentChunk++;
        if (currentChunk < chunks) {
          loadNext();
        } else {
          finishFun();
          //            console.log('finished');
          //            console.log(new Date().getTime() - startTime)
        }
      };
      fileReader.onerror = function () {
        console.warn("oops, something went wrong.");
      };

      function loadNext () {
        var start = currentChunk * chunkSize;
        var end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(
          blobSlice ? blobSlice.call(file, start, end) : file
        );
      }

      loadNext();
    }
  },
  name: "applyList"
};
</script>

<style lang="less" scoped>
/deep/ .el-table__expand-icon {
  display: none !important;
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
}
/deep/ .el-dialog__header {
  border-radius: 11px;
}
.node_header {
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #ed4031;
  background-size: 100%;
  font-size: 16px;
  color: #ffffff;
}
.hover-win {
  padding: 5px;

  .icontag:hover {
    background: whitesmoke;
  }
}

.icontag {
  color: #ddd;
}

.textEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #290202;
  opacity: 0.65;
}

.multiFile {
  position: absolute;
  font-size: 12px;
  top: 0px;
  left: -12px;
  width: 22px;
  height: 16px;
  line-height: 16px;
  background-color: #eb090a;
  color: #ffffff;
  text-align: center;
  border-radius: 4px;
  transform: scale(0.8);
  z-index: 2;

  &:after {
    content: "";
    position: absolute;
    bottom: -4px;
    right: 4px;
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid #eb090a;
    z-index: 1;
  }
}

.edit {
  color: #290202;
  font-weight: bold;

  &:hover {
    color: #ec1c1c;
  }
}

.nosign-url {
  font-size: 12px;
  color: #666666;
  margin-bottom: 20px;
}

.query-label {
  font-weight: 600;
  white-space: nowrap;
}

.bulkOperation {
  width: 85%;
  height: 50px;
  background: #f9f9f9;
  position: absolute;
  top: 99px;
  left: 140px;
  display: flex;
  align-items: center;
  color: rgba(41, 2, 2, 0.45);
}

.apply-list {
  max-width: 1200px;
  margin: 0 auto;
}

.pageation {
  padding: 30px 10px 20px 10px;
  border-top: 0;
}

.dialog-footer {
  padding-bottom: 20px;

  .btn {
    width: 30%;
  }
}

nav.nav-bar {
  width: 100%;
  margin-top: 20px;
  border: 1px dashed #d7d7d7;
  overflow: hidden;

  li.nav-item {
    margin-right: 14px;
    padding: 10px 15px;
    color: #666;
    border: none;
    background: #fff;
    cursor: pointer;
  }

  .nav-item.active {
    color: #ec1c1c;
  }

  ul.nav {
    width: 100%;
  }
}

.custom-link {
  cursor: pointer;
  color: rgba(41, 2, 2, 1);
  font-weight: 800;
}

.custom-link:hover {
  color: #ec1c1c;
  text-decoration: underline;
}

.ly-mask {
  .tips {
    color: rgb(115, 90, 90);
    font-size: 12px;
    text-align: left;
  }

  .box-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-left: -20px;
    margin-top: -15px;
    padding: 15px;

    &:last-child {
      /* margin-bottom: 130px; */
    }

    .temone {
      position: relative;
      margin: 15px 0 0 20px;
      width: 175px;
      text-align: center;
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;

      &.add {
        cursor: pointer;
        height: 140px;
        line-height: 140px;
        display: flex;
        justify-content: center;
        align-items: center;

        .file-ipt {
          width: inherit;
          height: inherit;
          position: absolute;
          opacity: 0;
        }

        &:hover {
          box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
        }
      }

      &.temone-center {
        height: 140px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .t-box {
          width: 100%;
          height: 75%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          overflow: hidden;
          .y-img {
            margin-top: 0;
          }
        }

        .tpid {
          width: 100%;
          height: 25%;
          background: #eeeeee;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      &:hover {
        .t-box {
          .msk {
            width: 100%;
            height: 100%;
            opacity: 1;
          }
        }

        .has-hover {
          display: block;
        }

        .no-hover {
          display: none;
        }
      }

      .t-box {
        position: relative;
        height: 105px;
        overflow: hidden;

        .y-img {
          width: 46px;
          height: 54px;
          display: block;
          margin: 17px auto 7px auto;
        }

        p {
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 0 10px;
          width: 100%;
          font-family: Source Han Sans SC;
          color: rgba(41, 2, 2, 0.65);
          box-sizing: border-box;
        }

        .msk {
          transition: all ease 0.2s;
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          background: rgba(0, 0, 0, 0.5);
          opacity: 0;
          padding: 8px 8px;
          box-sizing: border-box;

          .des {
            margin-top: 20px;
            font-size: 12px;
            text-align: left;
          }
          p{
            color: rgba(41, 2, 2, .65);
          }

          span {
            cursor: pointer;
            color: #ffffff;
            margin-left: 10px;
          }
        }
      }

      .b-box {
        display: flex;
        justify-content: space-between;
        align-items: center;

        a {
          width: 50%;
        }
      }

      .el-icon-plus {
        cursor: pointer;
        color: #c9bfbf;
        font-size: 80px;
      }
    }
  }

  .a-btn {
    cursor: pointer;
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: rgba(41, 2, 2, 1);
    text-decoration: none;
    border-radius: 0px 0px 4px 4px;
    background: rgba(239, 239, 239, 1);

    a {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;

      &:hover {
        color: rgba(236, 28, 28, 1);
      }
    }

    .has-hover {
      display: none;
    }

    .no-hover {
      display: block;
    }
  }
}

/deep/ .ly-info .el-tabs__item.is-active {
  color: rgb(236, 28, 28);
}

/deep/ .ly-info .el-tabs__active-bar {
  background-color: rgb(236, 28, 28);
}

/deep/ .ly-info .el-tabs__item {
  color: rgb(158, 140, 140);
}

.footer {
  height: 50px;
  position: relative;

  .num {
    margin-left: 20px;
    font-size: 14px;
    color: rgb(140, 140, 140);

    label {
      color: #ec1c1c;
    }
  }

  .cancel-btn {
    position: absolute;
    right: 20px;
  }
}

/deep/ .ly-info .el-dialog__body {
  height: 420px;
  overflow-y: auto;
}

/deep/ .ly-info .el-dialog__footer {
  text-align: left;
}
</style>
<style lang="less">
.el-popper .popper__arrow::after {
  border-bottom-color: #f5f6f6 !important;
}
</style>



// WEBPACK FOOTER //
// pages/corp/signInfo/applyList.vue